module.exports = __webpack_public_path__ + "img/logoCV.17db26b0.png";